import { PropsWithChildren } from 'react';
import type { UseInfiniteScrollHookRefCallback } from 'react-infinite-scroll-hook';
import { NoData } from '@sib/ui';
import { EntityCommentCardSkeleton } from './EntityCommentCardSkeleton';

const SKELETON_COUNT = 3;

interface EntityCommentsListProps extends PropsWithChildren {
  isLoading: boolean;
  isPending: boolean;
  isEmpty: boolean;
  hasNextPage?: boolean;
  isFetchingNextPage: boolean;
  sentryRef: UseInfiniteScrollHookRefCallback;
  emptyLabel: string;
  hasBadge?: boolean;
}

export const EntityCommentsList = ({
  isLoading,
  isPending,
  isEmpty,
  hasNextPage,
  isFetchingNextPage,
  sentryRef,
  emptyLabel,
  hasBadge,
  children,
}: EntityCommentsListProps) => {
  if (isLoading)
    return (
      <div className="flex max-h-[50vh] flex-col gap-3 overflow-y-auto">
        {Array.from({ length: SKELETON_COUNT }, (_, index) => (
          <EntityCommentCardSkeleton
            key={`entity-comment-skeleton-${index}`}
            hasBadge={hasBadge}
          />
        ))}
      </div>
    );

  if (isEmpty) return <NoData title={emptyLabel} className="py-10" />;

  return (
    <div className="flex max-h-[50vh] flex-col gap-3 overflow-y-auto pr-1">
      {children}

      {!isPending && (isFetchingNextPage || hasNextPage) && (
        <div ref={sentryRef} className="flex flex-col gap-3">
          {Array.from({ length: SKELETON_COUNT }, (_, index) => (
            <EntityCommentCardSkeleton
              key={`entity-comment-loading-${index}`}
              hasBadge={hasBadge}
            />
          ))}
        </div>
      )}
    </div>
  );
};
